import axios from "axios";
import { createClaimFailure, 
	createClaimStart, 
	createClaimSuccess, 
	getClaimsFailure, 
	getClaimsStart, 
	getClaimsSuccess,
	getClaimFailure, 
	getClaimStart, 
	getClaimSuccess } from "./ClaimActions";
	
import { apiUrl } from "../../config";

export const getClaims = async (dispatch) => {
	dispatch(getClaimsStart());
	try {
		const res = await axios.get(apiUrl + "/salesforce/" + JSON.parse(sessionStorage.getItem("user")).salesforceAccountId + "/cases",{
			headers: {
				Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user")).accessToken
			}
		});
		dispatch(getClaimsSuccess(res.data));
	} catch (error) {
		dispatch(getClaimsFailure());
	}
};

export const getClaim = async (id, dispatch) => {
	dispatch(getClaimStart());
	try {
		const res = await axios.get(apiUrl + "/salesforce/" + JSON.parse(sessionStorage.getItem("user")).salesforceAccountId + "/cases/"+ id,{
			headers: {
				Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user")).accessToken
			}
		});
		dispatch(getClaimSuccess(res.data));
	} catch (error) {
		dispatch(getClaimFailure());
	}
};

export const createClaim = async (claim, dispatch) => {
	dispatch(createClaimStart());
	
	try {
		const res = await axios.post(apiUrl + "/salesforce/" + JSON.parse(sessionStorage.getItem("user")).salesforceAccountId + "/cases/newcase", claim, {
			headers: {
				Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user")).accessToken,
				"Content-Type": "multipart/form-data"
			}
		});

		dispatch(createClaimSuccess(res.data));
	} catch (error) {
		dispatch(createClaimFailure());
	}
};